import React from 'react';
import './footer-menu-link.scss';

const FooterMenuLink = (props) => (
    <a
        className="footer-menu-link"
        href={`/${props.language}${props.url}`}
    >
        {props.name}
    </a>
);

export default FooterMenuLink;
